import React from 'react';

import type { Sort } from 'stores/PaginationTypes';
import { PaginatedEntityTable } from 'components/common';
import type { SharedCollectionListItem, SharedCollectionsFilterableBy } from 'collections/types';
import { fetchPaginatedSharedCollections, keyFn } from 'collections/hooks/useSharedCollections';

import customColumnRenderers from './customColumnRenderers';

export const DEFAULT_LAYOUT = {
  entityTableId: 'shared_collections',
  defaultPageSize: 20,
  defaultSort: { attributeId: 'title', direction: 'asc' } as Sort,
  defaultDisplayedAttributes: ['title', 'description', 'manage', 'content'],
};

const COLUMNS_ORDER = ['title', 'description', 'manage', 'content'];

type Props = {
  filterBy: SharedCollectionsFilterableBy;
  id: string;
};

const CollectionsList = ({ filterBy, id }: Props) => (
  <PaginatedEntityTable<SharedCollectionListItem>
    actionsCellWidth={250}
    humanName="collections"
    columnsOrder={COLUMNS_ORDER}
    tableLayout={DEFAULT_LAYOUT}
    entityActions={() => null}
    fetchEntities={(searchParams) => fetchPaginatedSharedCollections(searchParams, filterBy, id)}
    keyFn={(searchParams) => keyFn(searchParams, filterBy, id)}
    columnRenderers={customColumnRenderers}
    entityAttributesAreCamelCase={false}
    searchPlaceholder="Search for collection"
  />
);

export default CollectionsList;
